export default __webpack_public_path__ + "static/markhamTransparent-92b491e82fb3c9059338683ce929aff5.png";